var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"root",staticClass:"ui-toggle-switcher",class:[{'disabled': _vm.disabled, 'checked': _vm.yesValue === _vm.innerValue}, _vm.type],attrs:{"tabindex":_vm.disabled? -1:0},on:{"focus":_vm.onGetFocus,"blur":_vm.onBlur,"click":_vm.toggle}},[_c('div',{staticClass:"slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }